let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbeOd")).then(() => parcelRequire('cis96'));